import styled, { StyledProps } from 'styled-components'
import { IPropHref } from '@ucheba/utils/helpers/components/prop.types'

const ImageWrapper = styled.div<StyledProps<IPropHref>>`
  img {
    border-radius: 50%;
  }
`

const Block = styled.div<StyledProps<IPropHref>>``

export default { Block, ImageWrapper }
